module.exports = __webpack_public_path__ + "static/media/logo.c7fed602.svg";